import { Components } from '@mui/material/styles'

export const MuiPaperOverrides: Components['MuiPaper'] = {
  styleOverrides: {
    root: {
      borderRadius: 1.5, // 12px (1.5 * 8px)
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    elevation1: {
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    elevation2: {
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    },
    elevation3: {
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
  },
}
